var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKmPlusNew = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 6.25a.857.857 0 0 1 .857.857v4.286h4.286a.857.857 0 1 1 0 1.714h-4.286v4.286a.857.857 0 1 1-1.714 0v-4.286H6.857a.857.857 0 0 1 0-1.714h4.286V7.107A.857.857 0 0 1 12 6.25",
  clipRule: "evenodd"
})));
export default SvgKmPlusNew;